<!-- 【前台首页】 -->
<template>
  <div class="front-body">
    <el-card class="box-card" style="min-height: 865px">
    <div slot="header" class="clearfix">
      <sui-breadcrumb></sui-breadcrumb>
    </div>
      <el-tabs type="card" v-model="activeName" @tab-click="tabClick">
        <el-tab-pane v-for="item in typeArray" :name="item.dictValue" :key="item.dictValue">
          <span slot="label">{{item.dictLabel}}</span>
        </el-tab-pane>
      </el-tabs>
      <sui-info v-for="item in dataList" :key="item.id"
                @click.native="toPage({name:'worksDetails',query:{id:item.id}})"
                :title="item.name"
                :imgsrc="item.picture"
                :content="item.introduce"
                :date="item.keyWord">
      </sui-info>
    </el-card>
    <el-backtop target=".front-page" :bottom="100" :visibility-height="50"></el-backtop>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName:1,
        dataList: [],
        total:0,
        queryForm: {
          current: 1,
          size: 5,
          type:1,
          id: "",
          picture: "",
          title: "",
          name: "",
          categoryId: "",
          content: ""
        },
      }
    },
    computed: {
      //【消息类型】数组
      typeArray: function() {
        return this.$store.getters.getDictArray('works_type');
      },
    },
    mounted(){
      //初始化数据
      this.getList();
    },
    methods: {
      //点击搜索
      handleQuery() {
        this.queryForm.current = 1;
        this.getList();
      },
      tabClick(e){
        this.queryForm.type = e.name;
        this.getList();
      },
      //查询列表数据
      getList() {
        const loading = this.$loading({
          lock: true,
          text: '请稍后,加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0,0,0,0.25)'
        });
        this.$request.doGet('/api/works/getPage',this.queryForm).then(res => {
          if (res.isOk) {
            this.dataList = res.obj.records;
            loading.close();
          }
        });
      },
      //重置查询
      resetQuery() {
        this.$refs['queryForm'].resetFields();
        this.handleQuery();
      },
      //选择页码
      handleCurrentChange: function (currentPage) {
        this.queryForm.current = currentPage;
        this.getList();
      },
    }
  }
</script>
<style scoped>
  .search {
    padding-top: 50px;
    border-radius: 5px;
    text-align: center;
    background: white;
    height: 150px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
  }

  .search-btn {
    width: 500px
  }

  .category {
    padding: 10px
  }

  .category-link {
    padding: 5px 20px
  }
</style>




// WEBPACK FOOTER //
// src/pages/front/service/item/works.vue